<script setup async>
import AvatarImageLoader from "~/components/loaders/AvatarImageLoader.vue";
const {items: testimonials, getItems: getTestimonials} = useCrudApi('api/v2/testimonials');
await getTestimonials(1, 1);
</script>

<template>
  <div>
    <div class="tl-section-head">
      <h2>What our users are saying</h2>
    </div>
    <div class="testimonial-grid">
      <div class="tl-card testimonial-card" v-for="testimonial in testimonials" :key="testimonial.id">
        <div class="quote written-content" v-html="testimonial.body"></div>
        <div class="who">
          <avatar-image-loader :image-file-name="testimonial.imageFileName" size="34"/>
          <div class="name">{{ testimonial.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.testimonial-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

@media (min-width: 600px) {
  .testimonial-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (min-width: 960px) {
  .testimonial-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* single testimonial reads better full width */
.testimonial-grid:has(.testimonial-card:only-child) {
  grid-template-columns: 1fr;
}

.testimonial-card {
  padding: 16px;

  .quote {
    font-size: 13px;
    line-height: 1.7;
    color: rgb(var(--v-theme-charcoal));
    font-weight: 400;
  }

  .who {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 14px;

    .name {
      font-size: 12.5px;
      font-weight: 700;
    }
  }
}
</style>
